import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the layout-related state structure
interface LayoutState {
  layoutType: string;
}

// Initial layout state
const initialState: LayoutState = {
  layoutType: "AppLayout", // Default layout type
};

// Slice definition
const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLayoutType: (state, action: PayloadAction<string>) => {
      state.layoutType = action.payload;
    },
  },
});

export const { setLayoutType } = layoutSlice.actions;
export default layoutSlice.reducer;
